import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { TranslocoService } from '@jsverse/transloco';

import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';
import { Group, GroupService } from '../../../../providers/semantria-api/group.service';
import { SemantriaUser } from '../../../../providers/semantria-api/semantria-users.service';
import { AlertService } from '../../../../services/alert.service';

export interface GroupAddDialogOptions {
  user: SemantriaUser;
  allGroups: Group[];
}

@EnableClassTelemetry()
@Component({
  selector: 'app-group-add-dialog',
  templateUrl: './group-add-dialog.component.html',
  styleUrls: ['./group-add-dialog.component.scss'],
  standalone: false,
})
export class GroupAddDialogComponent implements OnInit, AfterViewInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  @ViewChild(MatSort, { static: false }) matSort: MatSort;

  displayedColumns = ['name'];

  allGroups: MatTableDataSource<Group>;
  selectedGroups: Group[] = [];

  isSaving: boolean;
  constructor(
    private groupService: GroupService,
    private alertService: AlertService,
    private dialogRef: MatDialogRef<GroupAddDialogComponent>,
    private translocoService: TranslocoService,
    @Inject(MAT_DIALOG_DATA) private data: GroupAddDialogOptions
  ) {
    this.allGroups = new MatTableDataSource<Group>(data.allGroups);
  }

  ngOnInit() {}

  ngAfterViewInit() {
    this.allGroups.sort = this.matSort;
    this.allGroups.sortData = (data, sort: MatSort) => {
      const direction = sort.direction === 'asc' ? 1 : -1;

      return data.sort((u1, u2) => {
        switch (sort.active) {
          case 'name':
            return u1.group_name.localeCompare(u2.group_name) * direction;
          default:
            return 0;
        }
      });
    };
  }

  isGroupSelected(group) {
    return this.selectedGroups.includes(group);
  }

  selectGroup(group) {
    const idx = this.selectedGroups.indexOf(group);
    if (idx !== -1) {
      this.selectedGroups.splice(idx, 1);
    } else {
      this.selectedGroups.push(group);
    }
  }

  cancel() {
    this.dialogRef.close();
  }

  add() {
    if (this.selectedGroups.length) {
      this.isSaving = true;

      this.groupService
        .addMemberToGroups(
          this.data.user.user_id,
          this.selectedGroups.map((group) => group.group_id)
        )
        .then(() => {
          this.dialogRef.close(this.selectedGroups);
          this.alertService.showToast(
            this.selectedGroups.length > 1
              ? this.translocoService.translate('group-add-dialog.add-success-plural')
              : this.translocoService.translate('group-add-dialog.add-success-singular')
          );
        })
        .catch(() => {
          this.isSaving = false;
          this.alertService.showToast(
            this.selectedGroups.length > 1
              ? this.translocoService.translate('group-add-dialog.add-failure-plural')
              : this.translocoService.translate('group-add-dialog.add-failure-singular')
          );
        });
    }
  }
}
